import React from 'react';
import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import ConductorAuto from 'containers/Auto/ConductorAuto';
import DatosAutoPantalla1 from 'containers/Auto/DatosAutoPantalla1';
import RecuperarAPIContainerAuto from 'containers/Auto/RecuperarAPIContainer';
import ResumenPlanPantalla3 from 'containers/Auto/ResumenPlanPantalla3Container';
import RiesgoAuto from 'containers/Auto/RiesgoAuto';
import SeleccionarPlanPantalla2 from 'containers/Auto/SeleccionaPlanPantalla2';
import VigenciaAutoPage from './Vigencia';

const AUTO_ROUTES = [
  <LayoutRoute
    exact={true}
    path="/auto/:idCotizacion?"
    layout={HomePublicaLayout}
    component={DatosAutoPantalla1}
    navBarTab="personas"
    validations={{
      prePolizaPagada: true,
    }}
  />,

  <LayoutRoute
    exact={true}
    path="/auto-planes/:idCotizacion?"
    layout={HomePublicaLayout}
    component={SeleccionarPlanPantalla2}
    navBarTab="personas"
    validations={{
      prePolizaPagada: true,
    }}
  />,

  <LayoutRoute
    exact={true}
    path="/auto-resumen/:idCotizacion?"
    layout={HomePublicaLayout}
    component={ResumenPlanPantalla3}
    navBarTab="personas"
    validations={{
      prePolizaPagada: true,
    }}
  />,

  <LayoutRoute
    exact
    path="/recuperar-cotizacion-auto"
    layout={HomePublicaLayout}
    component={RecuperarAPIContainerAuto}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact
    path="/riesgo-auto"
    layout={HomePublicaLayout}
    component={RiesgoAuto}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact
    path="/riesgo-auto-conductor"
    layout={HomePublicaLayout}
    component={ConductorAuto}
    navBarTab="personas"
  />,

  <LayoutRoute
    exact={true}
    path="/vigencia-auto"
    layout={HomePublicaLayout}
    component={VigenciaAutoPage}
    navBarTab="personas"
  />,
];

export default AUTO_ROUTES;
